// Common
import './lib/common/common.js';

// Load Web components
import '../components/kw-footer/kw-footer.js';
import '../components/kw-header/kw-header.js';
import '../components/kw-banner/kw-banner.js';
import '../components/kw-section/kw-section.js';
import '../components/kw-stage/kw-stage.js';

// Load libraries
import './lib/scroll/scroll.js';

import DataLanguage from './lib/data-language.js';
import dataBanner from './lib/dataBanner.js';
import dataBanners from '../json/bannerServiceDesignData.json';

const { lang } = document.querySelector('html');

function banner() {
  const bannerData = document.getElementById('banner-service-design');
  bannerData.innerHTML = `
          <kw-banner id="Banner" banner-size="ecommerce" animation-type="slide-toleft" change-interval="8">
              ${DataLanguage.dataLanguage(dataBanners.bannerServiceDesignData, lang).map(dataBanner.banner).join('')}
          </kw-banner>
    `;
}

function roleSectionAnimation() {
  const items = document.querySelectorAll('.service-design__role-item-container');
  const classList = ['translate_left', 'translate_bottom', 'translate_right'];
  Array.from(items).forEach((item, index) => item.classList.add(classList[index]));
}

function methodologySectionAnimation() {
  const items = document.querySelectorAll('.service-design__summary-item');
  const half = Math.ceil(items.length / 2);
  Array.from(items).forEach((item, index) => index !== 3
    && item.classList.add(index < half ? 'move_left' : 'move_right'));
}

function createObserver(element, callBack) {
  new IntersectionObserver((entries) => entries[0].isIntersecting && callBack()).observe(element);
}

if (document.addEventListener) {
  window.addEventListener('load', () => {
    banner();
    const roleItemContainer = document.querySelector('.service-design__role-item-container');
    const summaryList = document.querySelector('.service-design__summary-list');

    createObserver(roleItemContainer, roleSectionAnimation);
    createObserver(summaryList, methodologySectionAnimation);
  });
}
